// extracted by mini-css-extract-plugin
export var container = "benefitCard-module--container--fd312";
export var content = "benefitCard-module--content--b14a2";
export var icon = "benefitCard-module--icon--badc1";